module.exports = __webpack_public_path__ + "ProximaNova-Regular.c07517329a30d7a4d303f797171c7def.woff2";